<template>
  <button 
    :aria-label="tooltipText || ''"
    type="button"
    class="px-4 py-2 inline-flex uppercase group relative
          text-base font-normal text-nowrap
          text-skin-b-list-mute 
          hover:text-skin-b-list-base hover:bg-slate-300/40
          disabled:opacity-50 disabled:hover:bg-skin-active128 
          focus:outline-none focus:ring-0 
          transition duration-300 ease-in-out">
          
    <!-- Tooltip Element -->
    <span v-if="tooltipText" :class="tooltipClasses"
          class="opacity-0 group-hover:opacity-100
          transition-opacity duration-300 delay-[0ms] group-hover:delay-[2000ms]
          normal-case whitespace-nowrap max-w-xs truncate
          bg-slate-800 px-2 py-1 text-xs text-slate-100 rounded-md absolute">
      {{ tooltipText }}
    </span>
    
    <!-- Slot for Button Content -->
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'MyButton',
  props: {
    tooltipText: {
      type: String,
      default: '',
    },
    tooltipPosition: {
      type: String,
      default: 'top-center',
      validator: (value) => ['top-left', 'top-center', 'top-right'].includes(value),
    },
  },
  computed: {
    tooltipClasses() {
      switch (this.tooltipPosition) {
        case 'top-left':
          return 'left-0 top-0 -translate-x-0 -translate-y-full';
        case 'top-center':
          return 'left-1/2 top-0 -translate-x-1/2 -translate-y-full';
        case 'top-right':
          return 'right-0 top-0 -translate-x-0 -translate-y-full';
        default:
          return 'left-1/2 top-0 -translate-x-1/2 -translate-y-full';
      }
    },
  },
};
</script>

<style scoped>
</style>
